export default "__VITE_ASSET__R_6OzZQW__"